import { defineStore } from 'pinia'

export const useFormDataStore = defineStore('formData', {
  state: () => ({
    userCode: null,
    province: null,
    city: null,
    region: null,
    school: null,
    subjectSystem: null,
    classRank: null,
    gpaPoint: null,
    gpa: null,
    sat: null,
    englishType: null,
    englishScore: null,
    englishListening: null,
    englishSpoken: null,
    englishReading: null,
    englishWriting: null,
    major1st: null,
    major2nd: null,
    targetMajor: null,
    targetCountry: null,
    otherExperience: null,
    otherInfo: null,
    suggestion: null,
  }),
  getters: {
    formData: (state) => state 
  },
  actions: {
    setData(data) {
      Object.assign(this, data)
    }
  }
})